

export const locationPhrases = [
    "selecciona una de las ciudades",
    "en qué ciudad",
    "en que ciudad",
    "ciudades donde operamos",
    "selecciona la ciudad",
    "necesito que me indiques tu ubicación",
    "indica tu ubicación",
    "indiques tu ubicación",
    "necesito saber tu ubicación",
    "necesito conocer tu ubicación",
    "dónde te encuentras",
    "donde te encuentras",
    "cuál es tu ubicación",
    "cual es tu ubicación"
];

export const searchPhrases = [
    "buscaré las mejores opciones",
    "buscaré profesionales",
    "buscaré empresas",
    "buscaré opciones",
    "encontraré profesionales",
    "disponibles para esa fecha",
    "te mostraré las empresas disponibles",
    "buscaré la mejor opción",
    "te mostraré las empresas",
    "mostraré las empresas",
    "mostraré las mejores opciones",
    "te mostraré",
    "busco las mejores opciones para ti",
    "busco las mejores opciones",
    "busco profesionales",
    "busco empresas",
    "busco opciones",
    "mientras busco",
    "buscando las mejores opciones",
    "busco las mejores",
    "cambiaré tu solicitud",
    "mientras busco las mejores opciones",
    "opciones para ti",
    "busco las mejores opciones para ti",
    "permíteme un momento mientras busco",
    "permíteme buscar",
    "busco las mejores opciones"
];

export const dateTimePatterns = [
    /(?:qué|para que|a qué)\s+(?:día|hora|fecha)/i,
    /(?:cuándo|para cuándo)\s+necesitas/i,
    /(?:día|hora)\s+(?:necesitas|quieres|prefieres)/i,
    /(?:horario|disponibilidad|agenda)/i
];

export const searchPatterns = [
    // Patrones generales de búsqueda
    /permíteme\s+(?:un\s+momento|unos\s+minutos)\s+para\s+buscar/i,
    /permíteme\s+buscar/i,
    /voy\s+a\s+buscar/i,
    /buscaré\s+(?:la|las|el|los)?\s+(?:mejor|mejores)?/i,

    // Patrones específicos
    /cambiar\w+\s+(?:tu|la)\s+solicitud.*(?:busco|buscar|buscando)/i,
    /permíteme\s+(?:un\s+momento\s+)?(?:mientras\s+)?(?:busco|buscar)/i,
    /(?:busco|buscaré|buscando)\s+(?:las\s+)?(?:mejores\s+)?(?:profesionales|empresas|opciones|opción)/i,
    /no\s+hay\s+problema.*cambiar\w+\s+tu\s+solicitud/i,
    /te\s+mostraré\s+(?:las\s+)?(?:mejores\s+)?(?:profesionales|empresas|opciones)/i,
    /mientras\s+busco\s+(?:las\s+)?(?:mejores\s+)?(?:profesionales|empresas|opciones|opción)/i,
    /buscar\s+(?:la|las|el|los)?\s+(?:mejor|mejores)?\s+(?:opción|opciones)/i,

    // Nuevos patrones para detectar mensajes que indican que se proporcionarán opciones
    /(?:en\s+un\s+momento|pronto)\s+te\s+proporcionaré\s+(?:las\s+)?(?:opciones|profesionales|empresas)/i,
    /(?:te\s+proporcionaré|te\s+mostraré)\s+(?:las\s+)?(?:opciones|profesionales|empresas)\s+disponibles/i,
    /(?:confirmar|verificar)\s+(?:la\s+)?disponibilidad\s+de\s+(?:nuestros\s+)?(?:proveedores|profesionales|empresas)/i,
    /(?:opciones|profesionales|empresas)\s+disponibles\s+para\s+el\s+servicio/i
];

export const COMPANY_STATUS_PENDING_ADMIN = 'pendingAdmin';
export const COMPANY_STATUS_PENDING = 'pending';

export const USER_ROLES = {
    INMOBILIARIA: 'inmobiliaria',
    USER: 'user',
    COMPANY: 'company',
    ADMIN_PH: 'administradorPH',
    COMPANY_PARTNER: 'companyPatner',
    USER_ADMIN_UNIT: 'userAdminUnit',
    USER_PARTNER: 'userPatner'
}